"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficesActivityApiSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const officeActivityItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('offices'),
    attributes: zod_1.z.object({
        siteId: zod_1.z.string(),
        name: zod_1.z.string(),
        estimatedCaPerSlot: zod_1.z.number(),
        occupancy: zod_1.z.number().optional().default(0),
        doctorSubstitute: zod_1.z.object({
            nbSlots: zod_1.z.number(),
            estimatedCa: zod_1.z.number(),
        }),
        doctorAttending: zod_1.z.object({
            nbSlots: zod_1.z.number(),
            estimatedCa: zod_1.z.number(),
        }),
        openSlots: zod_1.z.object({
            nbSlots: zod_1.z.number(),
            estimatedCa: zod_1.z.number(),
        }),
        /** Set when the practice closed; closed practices stay in the statistics. */
        deactivatedAt: zod_1.z.coerce.date().nullable().default(null),
    }),
});
exports.getOfficesActivityApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(officeActivityItemApiResponseSchema);
